var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a, _b, _c;
import Vue from 'vue';
// remote requests to load config json-file and against the data warehouse
import axios from 'axios';
// date library
import * as moment from 'moment';
import { Const } from '../../const.mod';
import { Process } from '../../../lib/process/process.cls';
import { NSCaches } from './cache';
import { NSPatchers } from './patcher';
import { NSSeeders } from './seeder';
import { FifoItemValidator } from './cache/fifo-item-validator.cls';
/**
 * price feed provider implementation
 */
var PriceFeedProvider = /** @class */ (function (_super) {
    __extends(PriceFeedProvider, _super);
    function PriceFeedProvider(vuexStore) {
        var _this = _super.call(this, null) || this;
        /**
         * @Override
         * IE11 does not support function names for constructor
         * so we need to set it manually on implementation level
         * for class initialization from config.json in the
         * store mutations
         */
        _this.constructorName = PriceFeedProvider.TAG;
        /**
         * @Override
         * elements' validator for this provider
         */
        _this.itemValidator = null;
        /**
         * @Override
         * all seeders registered with this provider
         */
        _this.seeders = {};
        /**
         * @Override
         * all patchers registered with this provider
         */
        _this.patchers = {};
        // the cache to use
        _this.iCache = null;
        _this.vuexStore = null;
        _this.vuexStore = vuexStore;
        return _this;
        //this.log(PriceFeedProvider.TAG, 'pid', this.settings.pid)
    }
    /**
     * @Override
     * start process thread
     * start all registered componennts
     * params must be received from some vuex-mutation
     * and must contain the current jwt
     * @param params
     */
    PriceFeedProvider.prototype.start = function (params) {
        //this.log(PriceFeedProvider.TAG, 'start', params)
        this.settings = params;
        //this.log(PriceFeedProvider.TAG, 'start', this.settings)
        try {
            // start provider components
            this.initCache(params['cache']); // just one cache per provider
            this.initSeeders(params['seeders']); // multiple seeders
            this.initPatchers(params['patchers']); // multiple patchers
        }
        catch (ex) {
            //this.log(PriceFeedProvider.TAG, 'start', ex)
        }
    };
    /**
     * inject the JWT into all component settings
     * @param params list of component settings
     * @param token JWT
     */
    PriceFeedProvider.prototype.injectToken = function (params, token) {
        for (var p in params) {
            params[p]['token'] = token;
        }
    };
    /**
     * @Override
     * stop process thread
     * used by caches and providers and mains to stop all
     * registered providers and caches
     * @param params
     */
    PriceFeedProvider.prototype.stop = function (params) {
        try {
            this.iCache.stop();
        }
        catch (ex) {
            //this.log(PriceFeedProvider.TAG, 'stop cache [ex]', ex)
        }
        for (var p in this.seeders) {
            try {
                this.seeders[p].stop(params);
                delete this.seeders[p];
            }
            catch (ex) {
                //this.log(PriceFeedProvider.TAG, 'stop seeder [p, ex]', {p, ex})
            }
        }
        for (var p in this.patchers) {
            try {
                this.patchers[p].stop(params);
                delete this.patchers[p];
            }
            catch (ex) {
                //this.log(PriceFeedProvider.TAG, 'stop decorator [p, ex]', {p, ex})
            }
        }
        //this.log(PriceFeedProvider.TAG, 'stop done')
    };
    /**
     * @Override
     * add an item with new data
     */
    PriceFeedProvider.prototype.addItem = function (key, newItem) {
        this.iCache.addItem(key, newItem);
        this.heartbeat();
    };
    /**
     * @Override
     * add listof items with new data
     */
    PriceFeedProvider.prototype.addItems = function (mappings) {
        for (var p in mappings) {
            this.addItem(mappings[p].other.isinid, mappings[p]);
        }
    };
    /**
     * @Override
     * delegate method to patch an item with new data.
     * The ICache will handle the patching by either
     * adding it or using the IItemValidator to patch it.
     *  if 2nd arg is not provided
     * the ICache will remove the entry
     * @param key unique cache key
     * @param data new date for item
     */
    PriceFeedProvider.prototype.patchItem = function (key, newItem) {
        if (typeof newItem === 'undefined') {
            this.iCache.removeItem(key);
        }
        else {
            // add or patch through iCache's itemvalidator
            this.iCache.addItem(key, newItem);
        }
    };
    /**
     * @Override
     * patch items with new data
     * or remove them from cache if 2nd arg is provided
     */
    PriceFeedProvider.prototype.patchItems = function (mappings, remove) {
        for (var p in mappings) {
            if (remove) {
                this.patchItem(mappings[p]);
            }
            else {
                if (mappings[p].other) {
                    this.patchItem(mappings[p].other.isinid, mappings[p]);
                }
                else {
                    if (p) {
                        if (p == 'depth') {
                            this.patchItem(p, mappings[p]['0']);
                        }
                        else {
                            this.patchItem(p, mappings[p]);
                        }
                    }
                    else {
                        // console.log(p)
                    }
                }
            }
            this.heartbeat();
        }
    };
    /**
     * @Override
     * refresh a single cached item
     */
    PriceFeedProvider.prototype.refresh = function (iCacheable) {
        for (var d in this.patchers) {
            try {
                this.patchers[d].decorate(iCacheable);
                this.heartbeat();
            }
            catch (ex) { }
        }
    };
    /**
     * @Override
     * notify if an item in the cache was updated
     * @param params object that was updated
     */
    PriceFeedProvider.prototype.heartbeat = function (params) {
        params = params || { cacheItemTag: this.settings.cacheItemTag };
        this.vuexStore.dispatch(Const.RUN_HERARTBEAT, params);
    };
    /**
     * @Override
     * authenticate using the credentials inside params
     * @param params
     */
    PriceFeedProvider.prototype.auth = function (params) {
        try {
        }
        catch (ex) {
            //this.log(PriceFeedProvider.TAG, 'auth [ex]', ex.message)
        }
    };
    /**
     * @Override
     * initialize the cache
     * @param params optional arguments
     */
    PriceFeedProvider.prototype.initCache = function (params) {
        this.itemValidator = new FifoItemValidator(this);
        try {
            this.iCache = new NSCaches[params['className']](this);
            delete params['className'];
            // further start operations muse be handled by implementation 
            this.iCache.start(params);
        }
        catch (ex) {
            //this.log(PriceFeedProvider.TAG, 'init cache [ex]', ex)
        }
    };
    /**
     * @Override
     * @param params optional arguments
     * start all seeders registered with this provider
     */
    PriceFeedProvider.prototype.initSeeders = function (params) {
        for (var p in params) {
            try {
                var seeder = new NSSeeders[p](this);
                // further start operations muse be handled by implementation 
                seeder.start(params[p]);
                //this.log(PriceFeedProvider.TAG, 'initSeeders seeder pid', seeder.settings.pid)
                // add seeder under seeder's pid
                this.seeders[seeder.settings.pid] = seeder;
            }
            catch (ex) {
                //this.log(PriceFeedProvider.TAG, 'init seeders [ex]', ex)
            }
        }
    };
    /**
     * @Override
     * start all patchers registered with this provider
     * @param params
     */
    PriceFeedProvider.prototype.initPatchers = function (params) {
        for (var p in params) {
            try {
                var patcher = new NSPatchers[p](this);
                patcher.start(params[p]);
                // add decorator under decorator's pid
                this.patchers[patcher.settings.pid] = patcher;
            }
            catch (ex) {
                //this.log(PriceFeedProvider.TAG, 'init patchers [ex]', ex)
            }
        }
    };
    /**
     * @Override
     * stop all seeders registered with this provider
     * @param params
     */
    PriceFeedProvider.prototype.stopSeeders = function (params) {
        for (var p in this.seeders) {
            try {
                this.seeders[p].stop(params);
            }
            catch (ex) {
                //this.log(PriceFeedProvider.TAG, 'stop seeders [ex]', ex.message)
            }
        }
    };
    /**
     * @Override
     * stop all patchers registered with this provider
     * @param params optional arguments
     */
    PriceFeedProvider.prototype.stopPatchers = function (params) {
        for (var p in this.patchers) {
            try {
                this.patchers[p].stop(params);
            }
            catch (ex) {
                //this.log(PriceFeedProvider.TAG, 'stop patchers [ex]', ex.message)
            }
        }
    };
    /**
     * @Override
     * stop the cache registered with this provider
     */
    PriceFeedProvider.prototype.stopCache = function (params) {
        try {
            this.iCache.stop(params);
        }
        catch (ex) {
            //this.log(PriceFeedProvider.TAG, 'stop cache [ex]', ex.message)
        }
    };
    /**
     * @Override
     * get the vuex store
     */
    PriceFeedProvider.prototype.getStore = function () {
        return this.vuexStore;
    };
    // log tag
    PriceFeedProvider.TAG = 'PriceFeedProvider';
    return PriceFeedProvider;
}(Process));
export { PriceFeedProvider };
/**
 * constants for this provider
 */
export var PriceFeedProviderConst = {
    ///////////// actions //////////////////////
    // load security master data for one isin
    RUN_LOAD_PATCH: this.STORE_MODULE_NAME + '/' + this.REF +
        '/RUN_LOAD_PATCH',
    // search by result key(i.e. 'mn' for mnemonics) 
    // and param in the isin cache
    RUN_SEARCH_BY: this.STORE_MODULE_NAME + '/' + this.REF +
        '/RUN_SEARCH_BY',
    ///////////// mutations //////////////////////
    // update single patch for single provider
    SET_LOAD_PATCH: this.STORE_MODULE_NAME + '/' + this.REF +
        '/SET_LOAD_PATCH',
    // commit search result
    SET_SEARCH_BY: this.STORE_MODULE_NAME + '/' + this.REF +
        '/SET_SEARCH_BY',
    //////////////////// getters //////////////////////////////
    // get all search results
    GET_SEARCH_BY: this.STORE_MODULE_NAME + '/' + this.REF +
        '/GET_SEARCH_BY'
};
/**
 * store contributions for this provider
 */
export var PriceFeedProviderStore = {
    state: {
        searchResults: {} // reactive properties for the search results
    },
    actions: (_a = {},
        /**
         * @param params expects 'rk' for item prperty to search and
         * and 'p' for value
         */
        _a[PriceFeedProviderConst.RUN_SEARCH_BY] = function (_a, params) {
            var commit = _a.commit, state = _a.state, getters = _a.getters;
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + getters['GET_TOKEN'];
            axios.get(Const.WS_PRICE_FEED_DOMAIN.HOST +
                Const.WS_PRICE_FEED_DOMAIN.EP_API_SEARCH_BY, {
                params: params
            })
                .then(function (response) {
                var Subscribed_isins = getters[Const.GET_PROVIDERS]['priceFeed'].iCache.asKeysArray();
                // console.log("this will be subscribed isin", Subscribed_isins)
                for (var i = 0; i < response.data.data.m.length; i++) {
                    if (Subscribed_isins.indexOf(response.data.data.m[i].i) != -1) {
                        response.data.data.m[i].subscribed = 1;
                    }
                    else {
                        response.data.data.m[i].subscribed = 0;
                    }
                }
                commit(PriceFeedProviderConst.SET_SEARCH_BY, response.data.data);
            }).catch(function (e) {
                console.log('RUN_SEARCH_BY [e]', e);
            });
        },
        /**
         * for a single isin
         * load yesterday's close price and other security_master data
         * from data warehouse service
         * @param params
         * {
         *    isinId: array of isins-ids,
         *    callback: callback function for response
         *  }
         */
        _a[PriceFeedProviderConst.RUN_LOAD_PATCH] = function (_a, params) {
            var commit = _a.commit, state = _a.state, getters = _a.getters;
            if (isNaN(params['key'])) {
                return;
            }
            else {
                var cacheItemTag_1 = params['cacheItemTag'];
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + getters['GET_TOKEN'];
                axios.get(params['target'], {
                    params: {
                        i: params['key'],
                        d: moment().format(params['dateformat'])
                    }
                }).then(function (response) {
                    commit(PriceFeedProviderConst.SET_LOAD_PATCH, { cacheItemTag: cacheItemTag_1, response: response.data.data });
                }).catch(function (e) {
                    console.log('RUN_LOAD_PATCH [ex]');
                });
            }
        },
        _a),
    mutations: (_b = {},
        /**
         * update search result data in the state
         */
        _b[PriceFeedProviderConst.SET_SEARCH_BY] = function (state, params) {
            try {
                for (var key in params) {
                    Vue.set(state.searchResults, key, params[key]);
                }
            }
            catch (ex) {
                console.log('SET_SEARCH_BY [ex]');
            }
        },
        /**
         * update security_master data for a
         * single cache entry
         */
        _b[PriceFeedProviderConst.SET_LOAD_PATCH] = function (state, data) {
            var cacheItemTag = data['cacheItemTag'];
            var patches = data.response;
            for (var p in patches) {
                // patch items in cache
                state.providers[cacheItemTag].patchItem(p, patches[p]);
                var hb = state.heartbeats[cacheItemTag];
                try {
                    state.heartbeats[cacheItemTag]++;
                }
                catch (ex) {
                    state.heartbeats[cacheItemTag] = 0;
                }
            }
        },
        _b),
    getters: (_c = {},
        /**
         * return all current search results
         * against the price feed cache
         */
        _c[PriceFeedProviderConst.GET_SEARCH_BY] = function (state) {
            return state.searchResults;
        },
        _c)
};
/**
 * component mixins for this provider
 */
export var PriceFeedProviderMixins = {
    methods: {
        /**
             * subscribe to ISIN-id(s)
             * @param ids array of ISIN-ids to subscribe to
             */
        subscribe: function (ids) {
            this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                .seeders['S_PF_PF'].subscribe(ids);
        },
        /**
         * unsubscribe from ISIN-id(s)
         * @param ids array of ISIN-ids to unsubscribe from
         */
        unsubscribe: function (ids) {
            this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                .seeders['S_PF_PF'].unsubscribe(ids);
        },
        /**
          * Place limit order
    
        */
        // placeOrder(ids:Array<any>) {
        //   this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
        //     .seeders['S_PF_PF'].placeOrder(ids)
        // },
        /**
         * search provder cache for item attributes
         * @param rk name of the attribute, i.e. 'm' for mnemonics
         * @param p value to search for
         */
        searchCache: function (rk, p) {
            this.$store.dispatch(PriceFeedProviderConst.RUN_SEARCH_BY, { rk: rk, p: p });
        }
    },
    computed: {
        searchCacheResults: function () {
            return this.$store.getters[PriceFeedProviderConst.GET_SEARCH_BY]['m'];
        },
        instruments: function () {
            try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed'];
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                    .iCache.asObjectArray();
            }
            catch (ex) {
                // console.log('OO-one [ex]', ex)
                return [];
            }
        },
        user_isins: function () {
            try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed'];
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                    .iCache.asKeysValueArray();
            }
            catch (ex) {
                // console.log('OO-one [ex]', ex)
                return [];
            }
        },
        get_crypto: function () {
            try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed'];
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                    .iCache.getCryptoCurrency();
            }
            catch (ex) {
                // console.log('OO-one [ex]', ex)
                return [];
            }
        },
        get_crypto_depth: function () {
            try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed'];
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                    .iCache.getCryptoDepth();
            }
            catch (ex) {
                // console.log('OO-one [ex]', ex)
                return [];
            }
        },
        get_currencies: function () {
            try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed'];
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                    .iCache.getCurrencies();
            }
            catch (ex) {
                // console.log('OO-one [ex]', ex)
                return [];
            }
        },
        all_currencies_price: function () {
            try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed'];
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                    .iCache.asKeysValueArrayAll();
            }
            catch (ex) {
                // console.log('OO-one [ex]', ex)
                return [];
            }
        },
        all_instruments_key: function () {
            try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed'];
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                    .iCache.getSegmentType();
            }
            catch (ex) {
                // console.log('OO-one [ex]', ex)
                return [];
            }
        },
        get_Indices: function () {
            try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed'];
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                    .iCache.getIndices();
            }
            catch (ex) {
                // console.log('OO-one [ex]', ex)
                return [];
            }
        },
        get_Indices_all: function () {
            try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed'];
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                    .iCache.getIndicesAll();
            }
            catch (ex) {
                // console.log('OO-one [ex]', ex)
                return [];
            }
        },
        get_commodity: function () {
            try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed'];
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                    .iCache.getCommodity();
            }
            catch (ex) {
                // console.log('OO-one [ex]', ex)
                return [];
            }
        },
        get_Commodity_All: function () {
            try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed'];
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                    .iCache.getCommodityAll();
            }
            catch (ex) {
                // console.log('OO-one [ex]', ex)
                return [];
            }
        },
        get_all_currencies: function () {
            try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed'];
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                    .iCache.getAllcurrency();
            }
            catch (ex) {
                return [];
            }
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/provider/ws-price-feed/price-feed-provider.lib.ts
// module id = null
// module chunks = 